import React from "react";
import { Card, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import moment from "moment";
import warnIcon from "../../assets/images/warning_sign_gradient_shine.jpg";
import { convertCurrencyToSignNew, htmlDecode } from "../../utils/Constant";
import { payment_calender_icon } from "../../assets";

const currnencyText = {
  gbp: "UK Pounds",
  eur: "Euro",
};

function RequestCard({
  bill,
  handlePage,
  btn_title,
  signButton,
  showChargeAbleAmount = false,
  isDetailShow = false,
}) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (
      bill.agreement_config?.is_sign_agreement &&
      !bill?.is_agreement_signed
    ) {
      navigate(`/agreement/${bill.payment_request_slug}`);
    }
  };

  const replacedString = (string) => {
    if (string) {
      string = string.replace(
        /{exchange_rate}/g,
        `<span class="text-golden">${bill?.cost_in_one_pound}</span>`
      );
      string = string.replace(
        /{to_currency}/g,
        currnencyText[bill.converted_currency.toLowerCase()] +
          " (" +
          bill.converted_currency.toUpperCase() +
          ")"
      );
      return string;
    }
  };

  function calculateChargeableAmount(name = "initial_amount") {
    let baseAmount = 0;

    if (bill.plan.payment_access === "onetime") {
      baseAmount = bill.plan.total_amount;
    } else if (bill.plan.payment_access === "recursion") {
      baseAmount = bill.plan[name];
    }

    if (baseAmount <= 0) return 0;

    const vatAmount =
      bill.plan.vat_percentage > 0
        ? (baseAmount * bill.plan.vat_percentage) / 100
        : 0;

    const chargeableAmount = baseAmount + vatAmount;

    return parseFloat(chargeableAmount.toFixed(2));
  }

  return (
    <div className="payment-request-wrapper card-1 mb-4 p-4">
      {/* Card Header */}

      <div>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h4 className="mb-1">{bill?.request_title}</h4>
            <div className="d-flex align-items-center gap-2">
              <img src={payment_calender_icon}></img>
              <span className="light-text">
                {moment(bill.createdAt).format("DD MMM, YYYY")}
              </span>
            </div>
          </div>

          <div className="main-amount">£525.00</div>
        </div>

        {signButton &&
          bill.agreement_config &&
          bill.agreement_config.is_sign_agreement === true &&
          bill?.is_agreement_signed === false && (
            <Tooltip title="Please sign your agreement by clicking here">
              <img
                src={warnIcon}
                className="warning-icons"
                onClick={handleNavigate}
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 6,
                  cursor: "pointer",
                  border: "2px solid #fff",
                }}
                alt="Sign Agreement"
              />
            </Tooltip>
          )}
      </div>

      {/* Card Body */}
      <div className="mt-4">
        <div className="row g-3">
          {/* Request Type */}

          {/* Amount (Onetime) */}
          {bill.plan.trial_period_days > 0 && (
            <div className="col-12 col-md-6 col-xl-4">
              <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                <div className="flex-grow-1">
                  <div
                    className="fw-semibold text-secondary"
                    style={{ fontSize: 15 }}
                  >
                    Trial Period
                  </div>
                  <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                    {bill.plan.trial_period_days}{" "}
                    {bill.plan.trial_period_days > 1 ? "Days" : "Day"}
                  </div>
                </div>
              </div>
            </div>
          )}
          {bill.plan.payment_access === "onetime" && (
            <div className="col-12 col-md-6 col-xl-4">
              <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                <div className="flex-grow-1">
                  <div
                    className="fw-semibold text-secondary"
                    style={{ fontSize: 15 }}
                  >
                    Amount
                  </div>
                  <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                    {convertCurrencyToSignNew(bill.plan.plan_currency)}
                    {bill.plan.total_amount.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* recursion: Initial Deposit & Installments */}
          {bill.plan.payment_access === "recursion" && (
            <>
              <div className="col-12 col-md-6 col-xl-4">
                <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                  <div className="flex-grow-1">
                    <div
                      className="fw-semibold text-secondary"
                      style={{ fontSize: 15 }}
                    >
                      Initial Amount{" "}
                      <span style={{ fontSize: "10px" }}>(Excluding VAT)</span>
                    </div>
                    <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                      {convertCurrencyToSignNew(bill.plan.plan_currency)}
                      {bill.plan.initial_amount.toLocaleString()}
                      {bill.plan.trial_period_days > 0 &&
                        bill.payment_request_type === "pending" && (
                          <span style={{ fontSize: "10px" }}>
                            {" "}
                            (after the {bill.plan.trial_period_days}-day trial)
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* VAT */}

          <div className="col-12 col-md-6 col-xl-4">
            <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
              <div className="flex-grow-1">
                <div
                  className="fw-semibold text-secondary"
                  style={{ fontSize: 15 }}
                >
                  VAT
                </div>
                <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                  {bill.plan.vat_percentage ? bill.plan.vat_percentage : "0"}%
                </div>
              </div>
            </div>
          </div>

          {isDetailShow && (
            <>
              {/* Chargeable Amount */}
              {bill.plan.payment_access === "onetime" && (
                <div className="col-12 col-md-6 col-xl-4">
                  <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                    <div className="flex-grow-1">
                      <div
                        className="fw-semibold text-secondary"
                        style={{ fontSize: 15 }}
                      >
                        Chargeable Amount
                      </div>
                      <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                        {convertCurrencyToSignNew(bill.plan.plan_currency)}
                        {calculateChargeableAmount("total_amount")}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Chargeable Initial Amount */}
              {bill.plan.payment_access === "recursion" && (
                <div className="col-12 col-md-6 col-xl-4">
                  <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                    <div className="flex-grow-1">
                      <div
                        className="fw-semibold text-secondary"
                        style={{ fontSize: 15 }}
                      >
                        Chargeable Initial Amount
                      </div>
                      <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                        {convertCurrencyToSignNew(bill.plan.plan_currency)}
                        {calculateChargeableAmount("initial_amount")}
                        <span style={{ fontSize: "10px" }}>
                          {" "}
                          (after the {bill.plan.trial_period_days}-day trial)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {bill.plan.payment_access === "recursion" && (
            <>
              <div className="col-12 col-md-6 col-xl-4">
                <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                  <div className="flex-grow-1">
                    <div
                      className="fw-semibold text-secondary"
                      style={{ fontSize: 15 }}
                    >
                      {bill.plan.plan_type == "month"
                        ? "Monthly Installments"
                        : bill.plan.plan_type == "day"
                        ? "Daily Installment"
                        : "Yearly Installment"}{" "}
                      <span style={{ fontSize: "10px" }}>(Excluding VAT)</span>
                    </div>
                    <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                      {convertCurrencyToSignNew(bill.plan.plan_currency)}
                      {bill.plan.recurring_amount.toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Extra Detail Section */}
          {isDetailShow && (
            <>
              {/* Chargeable Installment */}
              {bill.plan.payment_access === "recursion" && (
                <div className="col-12 col-md-6 col-xl-4">
                  <div className="d-flex align-items-center gap-3 bg-light rounded p-3">
                    <div className="flex-grow-1">
                      <div
                        className="fw-semibold text-secondary"
                        style={{ fontSize: 15 }}
                      >
                        Chargeable Installment
                      </div>
                      <div className="fw-bold mt-1" style={{ fontSize: 16 }}>
                        {convertCurrencyToSignNew(bill.plan.plan_currency)}
                        {calculateChargeableAmount("recurring_amount")}
                        <span style={{ fontSize: "10px" }}>
                          {" "}
                          (after 1-
                          {`${bill.plan.plan_type}`} of initial payment)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {bill.transaction_note && isDetailShow && (
            <div className="">
              <div className="d-flex align-items-start gap-3 bg-light rounded p-3">
                <div
                  style={{
                    width: "22px",
                  }}
                  className="mt-3"
                ></div>
                <div className="flex-grow-1">
                  <div
                    className="fw-semibold text-secondary"
                    style={{ fontSize: 15 }}
                  >
                    Payment Notes
                  </div>
                  <div
                    className="fw-bold mt-1"
                    style={{ fontSize: 16, whiteSpace: "pre-line" }}
                  >
                    {htmlDecode(bill.transaction_note)}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Normal Chargeable Amount Footer */}
        {showChargeAbleAmount && (
          <div className="mt-4 p-3 d-flex align-items-center justify-content-between bg-light rounded shadow-sm">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-bold" style={{ fontSize: 16 }}>
                {bill.payment_request_type !== "pending"
                  ? "Charged Amount"
                  : "Amount Due Today"}
                :
              </span>
            </div>
            <div className="fw-bold" style={{ fontSize: 20, color: "navy" }}>
              {convertCurrencyToSignNew(bill.plan.plan_currency)}
              {bill.plan.trial_period_days > 0 &&
              bill.payment_request_type == "pending"
                ? "0"
                : calculateChargeableAmount()}
            </div>
          </div>
        )}

        {/* Button */}
        {handlePage && (
          <div className="border-top mt-3 d-flex gap-3 align-items-center justify-content-between pt-4">
            <div className="green-chip">
              {bill.plan.payment_access === "onetime" ? "OneTime" : "Recurring"}
            </div>
            <button
              className="theme-button-outlined m-auto m-md-0"
              onClick={() => handlePage(bill)}
            >
              {btn_title}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default RequestCard;
